import React, {Component} from 'react';
import PropTypes from 'prop-types';

class PlainDropdown extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {items, ...props} = this.props;
        return (
            <select {...props}>
                {items.map(item =>
                    <option key={item.id} value={item.id}>{item.text}</option>)}
            </select>
        );
    }
}

export default PlainDropdown;


// WEBPACK FOOTER //
// ./src/controls/PlainDropdown.js